/**
 * Workspace search — the ⌘K overlay and the results page (`KLQ-20260905-001`, brief 06).
 *
 * "Related" is the quiet divider over hits found by meaning rather than by the words typed
 * (§5.4): they are appended under the exact matches, never mixed into them, and the label says
 * why a row without the typed word is there at all.
 */

export const searchEn = {
  'overlay.title': 'Search',
  'overlay.label': 'Search everything you can open',
  'overlay.placeholder': 'Drawings, tasks, comments, levels, projects, people…',
  'overlay.close': 'Close search',
  'overlay.hint': 'Type a drawing number, a task, a floor or what somebody wrote.',
  'overlay.keys': '↑ ↓ move · Enter opens · ⌘Enter all results · Esc closes',
  'overlay.showAll': 'Show all results',

  'group.drawing': 'Drawings',
  'group.task': 'Tasks',
  'group.comment': 'Comments',
  'group.node': 'Levels',
  'group.project': 'Projects',
  'group.person': 'People',
  'group.showAll': 'Show all',
  'group.related': 'Related',
  'group.pending': 'Looking for related results…',

  'empty.explains': 'Search covers the drawings, tasks, comments, levels, projects and people you can open.',
  'empty.title': 'No results for “{q}”',
  'empty.body': 'Check the spelling, or try the drawing number or the level instead.',
  'unavailable': 'Showing exact matches only. Related results are unavailable right now.',
  'error.load': 'Search did not answer. Try again.',
  'error.tooLong': 'A search is at most 200 characters.',

  'page.title': 'Search',
  'page.subtitle': 'Across every project you can open.',
  'page.label': 'Search',
  'page.tabs': 'Result type',
  'page.tab.all': 'All',
  'page.more': 'Load more',
  'page.loading': 'Loading results…',
  'page.start.title': 'Search the studio',
  'page.start.body': 'Drawings, tasks, comments, levels, projects and people: everything you can open.',
} as const;
